import React, {useState} from 'react';
import styles from './RecordWorkout.module.css';
import Header from '../Header';
import {useHistory} from 'react-router-dom';
import TextInput from '../TextInput';
import CustomButton from '../CustomButton';
import CalendarIcon from '../svgs/CalenderIcon';
import {rwbApi} from '../../../../shared/apis/api';
import Loading from '../Loading';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {isWorkoutValid} from '../../../../shared/utils/WorkoutValidationHelper';
import { isNullOrEmpty } from '../../../../shared/utils/Helpers';

export default function RecordWorkout() {
  const [miles, setMiles] = useState('');
  const [milesErrorText, setMilesErrorText] = useState('');
  const [stepsErrorText, setStepsErrorText] = useState('');
  const [timeErrorText, setTimeErrorText] = useState('');
  const [steps, setSteps] = useState('');
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');
  const [seconds, setSeconds] = useState('');
  const [loading, setLoading] = useState(false);

  const history = useHistory();


  const clearErrorWarnings = () => {
    setMilesErrorText('');
    setStepsErrorText('');
    setTimeErrorText('');
  };
  const convertToUTC = (time) => moment.utc(time.toISOString());
  const [workOutDate, setDate] = useState(
  moment(new Date()).utc(),
  );
  const handleDateChange = (date) => setDate(convertToUTC(date));
  const handleBack = () => {
    history.goBack()
  };

  const submitHandler = () => {
    clearErrorWarnings();
if(isNullOrEmpty(miles.toString()) || isNullOrEmpty(steps.toString()) || hours.length == 0 || minutes.length == 0 || seconds.length == 0)
{
  alert("Please enter all fields")
 return
}
    const {miles_error, steps_error, time_error} = isWorkoutValid(
      workOutDate,
      miles.toString(),
      steps.toString(),
      hours.toString(),
      minutes.toString(),
      seconds.toString(),
    );

    const duration = (
      parseInt(hours || 0) * 60 +
      parseInt(minutes || 0) +
      parseInt(seconds || 0) / 60
    ).toString();

    const payload = {
      entry_date: moment(workOutDate).format("YYYY-MM-DD"),
      miles: parseFloat(miles) || 0,
      steps: parseInt(steps) || 0,
      minutes: parseFloat(parseFloat(duration).toFixed(2)) || 0,
    };

    let data = JSON.stringify(payload);

    if (miles_error || steps_error || time_error) {
      setMilesErrorText(miles_error);
      setStepsErrorText(steps_error);
      setTimeErrorText(time_error);
      return;
    } else {
      setLoading(true);

      rwbApi
        .putWorkout(data)
        .then(() => {
          setLoading(false);
          handleBack();
        })
        .catch((err) => {
          console.log("err",err);
          setLoading(false);
        });
    }
  };

  return (
    <>
      {loading && (
        <Loading size={100} color={'var(--white)'} loading={true} right />
      )}
      <div className={styles.rootContainer}>
        <Header title={'Record Workout'} onBack={() => handleBack()} />
        <div className={styles.contentContainer}>
          <div className={styles.calendarContainer}>
            <CalendarIcon tintColor={'var(--primary)'} height={20} />
            <div>
                <DatePicker
                  placeholderText="Pick a Date"
                  selected={workOutDate.toDate()}
                  minDate={moment().toDate()} //set the minimum date to today
                  onChange={handleDateChange}
                />
              {/* <p>{location.state.eventStartTime}</p> */}
            </div>
          </div>
          <TextInput
            type="number"
            label={`Miles`}    
            value={miles && Math.max(0, miles)}
            onValueChange={(e) =>
              setMiles(e.target.value ? Number(e.target.value) : e.target.value)
            }
            error={milesErrorText}
            onEnter={submitHandler}
            min={0}
          />
          <TextInput
            type="number"
            label={`Steps`}
            placeholder={' '}
            value={steps && Math.max(0, steps)}
            onValueChange={(e) =>
              setSteps(e.target.value ? Number(e.target.value) : e.target.value)
            }
            className={styles.stepsInput}
            error={stepsErrorText}
            onEnter={submitHandler}
            min={0}
          />
          {/* {location.state.requiredUnit === 'minutes' && (
            <p
              style={{
                fontFamily: 'OpenSans',
                fontSize: 16,
                color: 'var(--grey)',
                textTransform: 'uppercase',
              }}>
              Required:
            </p>
          )} */}
          <div className={styles.timeInputsContainer}>
            <TextInput
              type="number"
              label={'Hours'}
              placeholder={' '}
              value={hours && Math.max(0, hours)}
              onValueChange={(e) =>
                setHours(
                  e.target.value ? Number(e.target.value) : e.target.value,
                )
              }
              min={0}
            />
            <TextInput
              type="number"
              label="Minutes"
              placeholder={' '}
              value={minutes && Math.max(0, minutes)}
              onValueChange={(e) =>
                setMinutes(
                  e.target.value ? Number(e.target.value) : e.target.value,
                )
              }
              className={styles.inputMinutes}
              min={0}
            />
            <TextInput
              type="number"
              label="Seconds"
              placeholder={' '}
              value={seconds && Math.max(0, seconds)}
              onValueChange={(e) =>
                setSeconds(
                  e.target.value ? Number(e.target.value) : e.target.value,
                )
              }
              min={0}
            />
          </div>
          <div>
            <p className="errorMessage">{timeErrorText}</p>
          </div>

          <div className={styles.submitButtonWrapper}>
            <CustomButton
              label={'Submit'}
              onClick={() => submitHandler()}
              buttonStyle={'primary'}
            />
          </div>
        </div>
      </div>
    </>
  );
}
